import {Component, inject} from '@angular/core';
import {RadioButtonModule} from 'primeng/radiobutton';
import {FormBuilder, FormControl, FormGroup, FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {FormElementComponent} from "../../../shared/forms/form-element/form-element.component";
import {FormTypes} from "../../../shared/forms/models/constants";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {InputSwitchModule} from "primeng/inputswitch";
import {Button} from "primeng/button";
import {EvidenceSvgPipe} from "../../../shared/pipes/evidence-svg.pipe";
import {UserProperties, UserPropertiesService} from "../../services/user-properties.service";
import {el} from "@fullcalendar/core/internal-common";
import {APP_CONFIG} from "../../../app-config";
import {UserService} from "../../../shared/services/user.service";
import {InputOtpModule} from "primeng/inputotp";
import {CookieService} from "ngx-cookie-service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-signature-settings',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        RadioButtonModule,
        TranslatePipe,
        InputSwitchModule,
        Button,
        EvidenceSvgPipe,
        InputOtpModule,
    ],
    templateUrl: './signature-settings.component.html',
    styleUrl: './signature-settings.component.scss'
})
export class SignatureSettingsComponent {
    appConfig = inject(APP_CONFIG);

    protected readonly FormTypes = FormTypes;
    dialogForm: FormGroup;
    isDeleteAccountDialogOpen: boolean = false;
    isAllDataResponse!: boolean;

    // Selected Language Variables
    isEnglish!: boolean;
    isGerman!: boolean;
    isTurkish!: boolean;
    userLangProperty!: UserProperties;

    // Selected Evidence Variables
    userEvidenceProperty!: UserProperties;
    isBasic!: boolean;
    isBasiccert!: boolean;
    isHigh!: boolean;
    isMax!: boolean;

    // Selected Law Region Variables
    userLawRegionProperty!: UserProperties;
    isEULaws!: boolean;
    isTRLaws!: boolean;
    isCHLaws!: boolean;


    constructor(private formBuilder: FormBuilder,
                private translateService: TranslateService,
                private userPropertiesService: UserPropertiesService,
                private userService: UserService,
                private cookieService: CookieService,
                private router: Router) {
        this.dialogForm = this.formBuilder.group({
            temp: new FormControl()
        });
    }

    ngOnInit() {

        this.changeLanguage(this.translateService.currentLang, true);

        this.userPropertiesService.getAllByGroup('settings').subscribe(res => {

            if (res.length > 0) {
                this.isAllDataResponse = true;
            }

            res.forEach((element) => {

                const key = element.userPropertyKey;
                const val = element.userPropertyValue;

                switch (key) {
                    case 'sipo.settings.language':
                        this.changeLanguage(val, true)
                        this.userLangProperty = element;
                        break;
                    case 'sipo.settings.evidence':
                        this.changeEvidence(val, true)
                        this.userEvidenceProperty = element;
                        break;
                    case 'sipo.settings.legal-space':
                        this.changeSelectedLaws(val, true);
                        this.userLawRegionProperty = element;
                        break;
                }
            })
        });
    }

    changeLanguage(lang: string, initialState: boolean = false): void {
        this.isEnglish = lang === 'en';
        this.isTurkish = lang === 'tr';
        this.isGerman = lang === 'de';

        this.translateService.use(lang);

        if (!initialState) {

            if (!this.isAllDataResponse || !this.userLangProperty) {
                this.userPropertiesService.create({
                    userPropertyKey: 'sipo.settings.language',
                    userPropertyValue: lang,
                    type: 'string',
                    propertyGroup: 'settings',
                }).subscribe({
                    next: res => {
                        console.log(res)
                    },
                    error: err => {
                        console.error(err)
                    },
                })
            } else {
                this.userLangProperty.userPropertyValue = lang;

                this.userPropertiesService.update(this.userLangProperty).subscribe({
                    next: res => {
                        console.log(res)
                    },
                    error: err => {
                        console.log(err)
                    }
                });
            }


        }
    }

    changeEvidence(evidence: string, initialState: boolean = false): void {
        this.isBasic = evidence === 'basic';
        this.isBasiccert = evidence === 'basiccert';
        this.isHigh = evidence === 'high';
        this.isMax = evidence === 'max';

        if (!initialState) {

            if (!this.isAllDataResponse || !this.userEvidenceProperty) {
                this.userPropertiesService.create({
                    userPropertyKey: 'sipo.settings.evidence',
                    userPropertyValue: evidence,
                    type: 'string',
                    propertyGroup: 'settings',
                }).subscribe({
                    next: res => {
                        console.log(res)
                    },
                    error: err => {
                        console.error(err)
                    },
                })
            } else {
                this.userEvidenceProperty.userPropertyValue = evidence;

                this.userPropertiesService.update(this.userEvidenceProperty).subscribe({
                    next: res => {
                        console.log(res)
                    },
                    error: err => {
                        console.log(err)
                    }
                });
            }
        }
    }

    changeSelectedLaws(lawRegion: string, initialState: boolean = false): void {
        this.isEULaws = lawRegion === 'eu';
        this.isCHLaws = lawRegion === 'ch';
        this.isTRLaws = lawRegion === 'tr';

        if (!initialState) {

            if (!this.isAllDataResponse || !this.userLawRegionProperty) {
                this.userPropertiesService.create({
                    userPropertyKey: 'sipo.settings.legal-space',
                    userPropertyValue: lawRegion,
                    type: 'string',
                    propertyGroup: 'settings',
                }).subscribe({
                    next: res => {
                        console.log(res)
                    },
                    error: err => {
                        console.error(err)
                    },
                })
            } else {
                this.userLawRegionProperty.userPropertyValue = lawRegion;

                this.userPropertiesService.update(this.userLawRegionProperty).subscribe({
                    next: res => {
                        console.log(res)
                    },
                    error: err => {
                        console.log(err)
                    }
                });
            }
        }
    }


    toggleDialog(): void {
        this.showConfirmButtons = true;
        this.isDeleteAccountDialogOpen = !this.isDeleteAccountDialogOpen;
    }

    showConfirmButtons= true;
    protected otp: any;
    protected otpError: any;


     deleteRequest() {
        this.showConfirmButtons = false;
        this.userService.putDeleteRequest().subscribe({
            next: value => {
                this.showConfirmButtons = false;
                console.log(value);
            },
            error: err => {
                console.log(err);
            }
        });
        console.log("");
    }

     deleteConfirm() {
        this.showConfirmButtons = false;

        this.otpError = "";
        if(!this.otp) {
            this.otpError = 'sipo.delete-account-otp-empty';

            return;
        }

        this.userService.deleteConfirm(this.otp).subscribe({
            next: value => {
                this.showConfirmButtons = false;
                this.logout();
                console.log(value);
            },
            error: err => {
                console.log(err);
                this.otpError = 'sipo.delete-account-not-valid-otp';
            }
        });
        console.log("");
    }

    logout() {
        this.cookieService.deleteAll();
        this.router.navigateByUrl('/').then(() => {
            window.location.reload();
        });
    }
}
